import {
  LOAD_LAYOUTS,
  ADD_LAYOUT,
  TOGGLE_IS_ACTIVE_LAYOUT,
  LOAD_LAYOUTS_BY_BOOK_ID,
  REMOVE_DEFAULT_LAYOUT,
} from '../../action-types/entities/layouts';
import {
  generateId,
} from '../../helpers/index';

export const STATE_KEY = 'layouts';

export const layouts = (state = {
  byId: {},
  allIds: [],
}, action) => {
  const byIdNumber = generateId(state.allIds);
  switch (action.type) {
    case LOAD_LAYOUTS_BY_BOOK_ID: {
      return action.bookState;
    }
    case LOAD_LAYOUTS:
      return action.layouts.slice(0);

    case ADD_LAYOUT: {
      const { layout } = action;
      //  const layoutOrientation = [];
      layout.order = state.allIds.length;
      layout.active = false;
      // layout.placeholders = layout.placeholders;
      layout.id = byIdNumber;

      /* for (const placeholder of layout.placeholders) {
        layoutOrientation.push(orientation(placeholder.width, placeholder.height));
      } */
      // layout.orientations = layoutOrientation;

      return {
        byId: {
          ...state.byId,
          [byIdNumber]: layout,
        },
        allIds: [...state.allIds, byIdNumber],
      };
    }

    case TOGGLE_IS_ACTIVE_LAYOUT: {
      const { layoutId } = action;
      const layoutsById = {};
      const stateLayouts = state.byId;

      for (const id in stateLayouts) {
        if (id in stateLayouts) {
          const page = Object.assign({}, stateLayouts[id]);
          page.active = layoutId === parseInt(id, 10);
          layoutsById[id] = page;
        }
      }
      return Object.assign({}, state, { byId: layoutsById });
    }

    case REMOVE_DEFAULT_LAYOUT: {
      const { layoutId } = action;
      const layoutsById = {};
      const byIdLayouts = state.byId;
      const allIdLayouts = state.allIds;


      for (const id in byIdLayouts) {
        if (id in byIdLayouts && byIdLayouts[id].id !== layoutId) {
          const page = Object.assign({}, byIdLayouts[id]);
          layoutsById[id] = page;
        }
      }

      const layoutsAllId = allIdLayouts.filter(element => element !== layoutId);

      return Object.assign({}, state, {
        allIds: layoutsAllId,
        byId: layoutsById,
      });
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/layouts.js